module.exports = __webpack_public_path__ + "static/media/TS_ThemeBox_App_TaurusStyle.25e318e9.jpg";